import { createFileRoute } from '@tanstack/react-router'
import { observer } from 'mobx-react-lite'
import { useCallback, useEffect, useState } from 'react'
import { cn } from '@/utils/ui.js'
import { LoadingIndicator } from '@/components/ui/loadingIndicator.jsx'
import { ONRAMPER_BASE_URL } from '@/constants/onramper.js'

const ALLOWED_ORIGINS = [
  'https://pay.pymstr.com',
  'https://pymstr-pay.promeet.pro',
  'https://127.0.0.1.sslip.io:3000',
]

const OnramperPage = () => {
  const [parentOrigin, setParentOrigin] = useState(null)
  const [src, setSrc] = useState('')
  const [isLoading, setIsLoading] = useState(true)

  const handleLoad = useCallback(() => {
    setIsLoading(false)
  }, [])

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const opt = {
      apiKey: import.meta.env.VITE_ONRAMPER_API_KEY,
      mode: 'buy',
      ...Object.fromEntries(params),
    }

    setSrc(`${ONRAMPER_BASE_URL}?${new URLSearchParams(opt).toString()}`)
    setIsLoading(true)
  }, [])

  useEffect(() => {
    const handleMessage = event => {
      if (ALLOWED_ORIGINS.includes(event.origin)) {
        setParentOrigin(event.origin)

        return
      }

      if (parentOrigin && window.parent) window.parent.postMessage(event.data, parentOrigin)
    }

    window.addEventListener('message', handleMessage)

    return () => window.removeEventListener('message', handleMessage)
  }, [parentOrigin])

  if (!src) return null

  return (
    <div className="relative h-screen w-screen">
      <iframe
        allow="accelerometer; autoplay; camera; gyroscope; payment; microphone"
        className="size-full"
        frameBorder="0"
        onLoad={handleLoad}
        sandbox="allow-same-origin allow-scripts allow-top-navigation allow-popups allow-forms allow-modals"
        src={src}
        title="Onramper Widget"
      />

      <div
        className={cn(
          'absolute inset-0 flex items-center justify-center backdrop-blur-sm transition-opacity backface-hidden',
          {
            'pointer-events-none opacity-0': !isLoading,
          }
        )}>
        <LoadingIndicator size={4} />
      </div>
    </div>
  )
}

export const Route = createFileRoute('/onramper')({
  component: observer(OnramperPage),
})
